export interface EmojiData {
  emoji: string;
  name: string; // Short name for search/id
}

export interface EmojiCategory {
  id: string;
  name: string;
  emojis: EmojiData[];
}

export const EMOJI_LIST: EmojiCategory[] = [
  {
    id: "smileys_people",
    name: "Smileys & People",
    emojis: [
      { emoji: "😀", name: "grinning_face" },
      { emoji: "😃", name: "big_eyes_grin" },
      { emoji: "😄", name: "smiling_eyes_grin" },
      { emoji: "😁", name: "beaming_smile" },
      { emoji: "😆", name: "squinting_laugh" },
      { emoji: "😅", name: "sweat_grin" },
      { emoji: "😂", name: "joy_tears" },
      { emoji: "🤣", name: "rofl_laugh" },
      { emoji: "🥲", name: "tear_smile" },
      { emoji: "☺️", name: "warm_smile" },
      { emoji: "😊", name: "blush_smile" },
      { emoji: "😇", name: "halo_smile" },
      { emoji: "🙂", name: "slight_smile" },
      { emoji: "🙃", name: "upside_down" },
      { emoji: "😉", name: "wink_face" },
      { emoji: "😌", name: "relieved_face" },
      { emoji: "😍", name: "heart_eyes" },
      { emoji: "🥰", name: "hearts_face" },
      { emoji: "😘", name: "blow_kiss" },
      { emoji: "😗", name: "kissing_face" },
      { emoji: "😙", name: "smiling_kiss" },
      { emoji: "😚", name: "closed_eyes_kiss" },
      { emoji: "😋", name: "yummy_face" },
      { emoji: "😛", name: "tongue_out" },
      { emoji: "😝", name: "squinting_tongue" },
      { emoji: "😜", name: "wink_tongue" },
      { emoji: "🤪", name: "zany_face" },
      { emoji: "🤨", name: "raised_eyebrow" },
      { emoji: "🧐", name: "monocle_face" },
      { emoji: "🤓", name: "nerd_face" },
      { emoji: "😎", name: "sunglasses_face" },
      { emoji: "🥸", name: "disguised_face" },
      { emoji: "🤩", name: "star_struck" },
      { emoji: "🥳", name: "partying_face" },
      { emoji: "😏", name: "smirking_face" },
      { emoji: "😒", name: "unamused_face" },
      { emoji: "😞", name: "disappointed_face" },
      { emoji: "😔", name: "pensive_face" },
      { emoji: "😟", name: "worried_face" },
      { emoji: "😕", name: "confused_face" },
      { emoji: "🙁", name: "slight_frown" },
      { emoji: "☹️", name: "frowning_face" },
      { emoji: "😣", name: "persevering_face" },
      { emoji: "😖", name: "confounded_face" },
      { emoji: "😫", name: "tired_face" },
      { emoji: "😩", name: "weary_face" },
      { emoji: "🥺", name: "pleading_face" },
      { emoji: "😢", name: "crying_face" },
      { emoji: "😭", name: "loudly_crying" },
      { emoji: "😤", name: "steam_nose" },
      { emoji: "😡", name: "pouting_face" },
      { emoji: "🤬", name: "cursing_face" },
      { emoji: "🤯", name: "exploding_head" },
      { emoji: "😳", name: "flushed_face" },
      { emoji: "🥵", name: "hot_face" },
      { emoji: "🥶", name: "cold_face" },
      { emoji: "😱", name: "screaming_fear" },
      { emoji: "😨", name: "fearful_face" },
      { emoji: "😰", name: "anxious_sweat" },
      { emoji: "😥", name: "relieved_sad" },
      { emoji: "😓", name: "downcast_sweat" },
      { emoji: "🤗", name: "hugging_face" },
      { emoji: "🤔", name: "thinking_face" },
      { emoji: "🤭", name: "hand_over_mouth" },
      { emoji: "🤫", name: "shushing_face" },
      { emoji: "🤥", name: "lying_face" },
      { emoji: "😶", name: "no_mouth" },
      { emoji: "😐", name: "neutral_face" },
      { emoji: "😑", name: "expressionless_face" },
      { emoji: "😬", name: "grimacing_face" },
      { emoji: "🙄", name: "rolling_eyes" },
      { emoji: "😯", name: "hushed_face" },
      { emoji: "😦", name: "frowning_open" },
      { emoji: "😧", name: "anguished_face" },
      { emoji: "😮", name: "open_mouth" },
      { emoji: "😲", name: "astonished_face" },
      { emoji: "🥱", name: "yawning_face" },
      { emoji: "😴", name: "sleeping_face" },
      { emoji: "🤤", name: "drooling_face" },
      { emoji: "😪", name: "sleepy_face" },
      { emoji: "😵", name: "dizzy_face" },
      { emoji: "🤐", name: "zipper_mouth" },
      { emoji: "🥴", name: "woozy_face" },
      { emoji: "🤢", name: "nauseated_face" },
      { emoji: "🤮", name: "face_vomiting" },
      { emoji: "🤧", name: "sneezing_face" },
      { emoji: "😷", name: "medical_mask" },
      { emoji: "🤒", name: "thermometer_face" },
      { emoji: "🤕", name: "bandage_head" },
      { emoji: "🤑", name: "money_mouth" },
      { emoji: "🤠", name: "cowboy_hat" },
      { emoji: "😈", name: "devil_smile" },
      { emoji: "👿", name: "devil_angry" },
      { emoji: "👹", name: "ogre_mask" },
      { emoji: "👺", name: "goblin_mask" },
      { emoji: "🤡", name: "clown_face" },
      { emoji: "💩", name: "poop_pile" },
      { emoji: "👻", name: "ghost_spooky" },
      { emoji: "💀", name: "skull_head" },
      { emoji: "☠️", name: "skull_crossbones" },
      { emoji: "👽", name: "alien_face" },
      { emoji: "👾", name: "alien_monster" },
      { emoji: "🤖", name: "robot_face" },
      { emoji: "🎃", name: "pumpkin_jack" },
      { emoji: "😺", name: "cat_grin" },
      { emoji: "😸", name: "cat_smile" },
      { emoji: "😹", name: "cat_joy" },
      { emoji: "😻", name: "cat_heart_eyes" },
      { emoji: "😼", name: "cat_smirk" },
      { emoji: "😽", name: "cat_kiss" },
      { emoji: "🙀", name: "cat_weary" },
      { emoji: "😿", name: "cat_crying" },
      { emoji: "😾", name: "cat_pouting" },
      { emoji: "👋", name: "waving_hand" },
      { emoji: "🤚", name: "raised_back_hand" },
      { emoji: "🖐️", name: "splayed_fingers" },
      { emoji: "✋", name: "raised_hand" },
      { emoji: "🖖", name: "vulcan_salute" },
      { emoji: "👌", name: "ok_hand" },
      { emoji: "🤌", name: "pinched_fingers" },
      { emoji: "🤏", name: "pinching_hand" },
      { emoji: "✌️", name: "victory_hand" },
      { emoji: "🤞", name: "crossed_fingers" },
      { emoji: "🤟", name: "love_you" },
      { emoji: "🤘", name: "rock_on" },
      { emoji: "🤙", name: "call_me" },
      { emoji: "👈", name: "point_left" },
      { emoji: "👉", name: "point_right" },
      { emoji: "👆", name: "point_up" },
      { emoji: "🖕", name: "middle_finger" },
      { emoji: "👇", name: "point_down" },
      { emoji: "☝️", name: "index_up" },
      { emoji: "👍", name: "thumbs_up" },
      { emoji: "👎", name: "thumbs_down" },
      { emoji: "✊", name: "raised_fist" },
      { emoji: "👊", name: "oncoming_fist" },
      { emoji: "🤛", name: "left_fist" },
      { emoji: "🤜", name: "right_fist" },
      { emoji: "👏", name: "clapping_hands" },
      { emoji: "🙌", name: "raising_hands" },
      { emoji: "👐", name: "open_hands" },
      { emoji: "🤲", name: "palms_up" },
      { emoji: "🤝", name: "handshake" },
      { emoji: "🙏", name: "folded_hands" },
      { emoji: "✍️", name: "writing_hand" },
      { emoji: "💅", name: "nail_polish" },
      { emoji: "🤳", name: "selfie_hand" },
      { emoji: "💪", name: "flex_biceps" },
      { emoji: "🦾", name: "robot_arm" },
      { emoji: "🦿", name: "robot_leg" },
      { emoji: "🦵", name: "leg_foot" },
      { emoji: "🦶", name: "foot_leg" },
      { emoji: "👂", name: "ear_listen" },
      { emoji: "🦻", name: "ear_hearing_aid" },
      { emoji: "👃", name: "nose_smell" },
      { emoji: "🧠", name: "brain_mind" },
      { emoji: "🫀", name: "anatomical_heart" },
      { emoji: "🫁", name: "lungs_organ" },
      { emoji: "🦷", name: "tooth_dentist" },
      { emoji: "🦴", name: "bone_skeleton" },
      { emoji: "👀", name: "eyes_look" },
      { emoji: "👁️", name: "eye_look" },
      { emoji: "👅", name: "tongue_lick" },
      { emoji: "👄", name: "mouth_lips" },
      { emoji: "💋", name: "kiss_mark" },
      { emoji: "🩸", name: "blood_drop" },
      { emoji: "👶", name: "baby_face" },
      { emoji: "🧒", name: "child_face" },
      { emoji: "👦", name: "boy_face" },
      { emoji: "👧", name: "girl_face" },
      { emoji: "🧑", name: "person_face" },
      { emoji: "👱", name: "blond_person" },
      { emoji: "👨", name: "man_face" },
      { emoji: "🧔", name: "beard_person" },
      { emoji: "👩", name: "woman_face" },
      { emoji: "🧓", name: "older_person" },
      { emoji: "👴", name: "old_man" },
      { emoji: "👵", name: "old_woman" },
      { emoji: "👲", name: "skullcap_person" },
      { emoji: "👳", name: "turban_person" },
      { emoji: "🧕", name: "headscarf_woman" },
      { emoji: "👮", name: "police_officer" },
      { emoji: "👷", name: "construction_worker" },
      { emoji: "💂", name: "guard_person" },
      { emoji: "🕵️", name: "detective_spy" },
      { emoji: "👩‍⚕️", name: "woman_doctor" },
      { emoji: "👨‍⚕️", name: "man_doctor" },
      { emoji: "👩‍🌾", name: "woman_farmer" },
      { emoji: "👨‍🌾", name: "man_farmer" },
      { emoji: "👩‍🍳", name: "woman_cook" },
      { emoji: "👨‍🍳", name: "man_cook" },
      { emoji: "👩‍🎓", name: "woman_student" },
      { emoji: "👨‍🎓", name: "man_student" },
      { emoji: "👩‍🎤", name: "woman_singer" },
      { emoji: "👨‍🎤", name: "man_singer" },
      { emoji: "👩‍🏫", name: "woman_teacher" },
      { emoji: "👨‍🏫", name: "man_teacher" },
      { emoji: "👩‍", name: "woman_factory" },
      { emoji: "👨‍", name: "man_factory" },
      { emoji: "👩‍💻", name: "woman_tech" },
      { emoji: "👨‍💻", name: "man_tech" },
      { emoji: "👩‍💼", name: "woman_office" },
      { emoji: "👨‍💼", name: "man_office" },
      { emoji: "👩‍🔧", name: "woman_mechanic" },
      { emoji: "👨‍🔧", name: "man_mechanic" },
      { emoji: "👩‍🔬", name: "woman_scientist" },
      { emoji: "👨‍🔬", name: "man_scientist" },
      { emoji: "👩‍🎨", name: "woman_artist" },
      { emoji: "👨‍🎨", name: "man_artist" },
      { emoji: "👩‍🚒", name: "woman_firefighter" },
      { emoji: "👨‍🚒", name: "man_firefighter" },
      { emoji: "👩‍✈️", name: "woman_pilot" },
      { emoji: "👨‍✈️", name: "man_pilot" },
      { emoji: "👩‍🚀", name: "woman_astronaut" },
      { emoji: "👨‍🚀", name: "man_astronaut" },
      { emoji: "👩‍⚖️", name: "woman_judge" },
      { emoji: "👨‍⚖️", name: "man_judge" },
      { emoji: "👰", name: "bride_wedding" },
      { emoji: "🤵", name: "groom_tuxedo" },
      { emoji: "👸", name: "princess_crown" },
      { emoji: "🤴", name: "prince_crown" },
      { emoji: "🦸", name: "superhero_person" },
      { emoji: "🦹", name: "supervillain_person" },
      { emoji: "🤶", name: "mrs_claus" },
      { emoji: "🎅", name: "santa_claus" },
      { emoji: "🧙", name: "mage_wizard" },
      { emoji: "🧝", name: "elf_fantasy" },
      { emoji: "🧛", name: "vampire_dracula" },
      { emoji: "🧟", name: "zombie_undead" },
      { emoji: "🧞", name: "genie_magic" },
      { emoji: "🧜", name: "mermaid_person" },
      { emoji: "🧚", name: "fairy_magic" },
      { emoji: "👼", name: "angel_baby" },
      { emoji: "🤰", name: "pregnant_woman" },
      { emoji: "🤱", name: "breast_feeding" },
      { emoji: "🙇", name: "bowing_person" },
      { emoji: "💁", name: "tipping_hand" },
      { emoji: "🙅", name: "gesturing_no" },
      { emoji: "🙆", name: "gesturing_ok" },
      { emoji: "🙋", name: "raising_hand" },
      { emoji: "🧏", name: "deaf_person" },
      { emoji: "🤦", name: "face_palm" },
      { emoji: "🤷", name: "shrugging_person" },
      { emoji: "🙎", name: "pouting_person" },
      { emoji: "🙍", name: "frowning_person" },
      { emoji: "💇", name: "haircut_person" },
      { emoji: "💆", name: "massage_person" },
      { emoji: "🧖", name: "sauna_person" },
      { emoji: "💃", name: "woman_dancing" },
      { emoji: "🕺", name: "man_dancing" },
      { emoji: "👯", name: "bunny_friends" },
      { emoji: "🕴️", name: "levitating_suit" },
      { emoji: "🚶", name: "walking_person" },
      { emoji: "🏃", name: "running_person" },
      { emoji: "🧍", name: "standing_person" },
      { emoji: "🧎", name: "kneeling_person" },
      { emoji: "👨‍🦯", name: "blind_cane" },
      { emoji: "👨‍🦼", name: "motor_wheelchair" },
      { emoji: "👨‍🦽", name: "manual_wheelchair" },
      { emoji: "🧗", name: "climbing_person" },
      { emoji: "🤺", name: "fencing_person" },
      { emoji: "🏇", name: "horse_racing" },
      { emoji: "⛷️", name: "skier_snow" },
      { emoji: "🏂", name: "snowboarder_snow" },
      { emoji: "🏌️", name: "golfing_person" },
      { emoji: "🏄", name: "surfing_person" },
      { emoji: "🚣", name: "rowing_person" },
      { emoji: "🏊", name: "swimming_person" },
      { emoji: "⛹️", name: "basketball_person" },
      { emoji: "🏋️", name: "lifting_weights" },
      { emoji: "🚴", name: "biking_person" },
      { emoji: "🚵", name: "mountain_biking" },
      { emoji: "🤸", name: "cartwheel_person" },
      { emoji: "🤼", name: "wrestling_people" },
      { emoji: "🤽", name: "water_polo" },
      { emoji: "🤾", name: "handball_person" },
      { emoji: "🤹", name: "juggling_person" },
      { emoji: "🧘", name: "yoga_lotus" },
      { emoji: "🛀", name: "bath_person" },
      { emoji: "🛌", name: "bed_person" }
    ]
  },
  {
    id: "animals_nature",
    name: "Animals & Nature",
    emojis: [
      { emoji: "🐵", name: "monkey_face" },
      { emoji: "🐶", name: "dog_face" },
      { emoji: "🐺", name: "wolf_face" },
      { emoji: "🐱", name: "cat_face" },
      { emoji: "🦁", name: "lion_face" },
      { emoji: "🐯", name: "tiger_face" },
      { emoji: "🐴", name: "horse_face" },
      { emoji: "🦄", name: "unicorn_face" },
      { emoji: "🐮", name: "cow_face" },
      { emoji: "🐷", name: "pig_face" },
      { emoji: "🐭", name: "mouse_face" },
      { emoji: "🐰", name: "rabbit_face" },
      { emoji: "🐻", name: "bear_face" },
      { emoji: "🐨", name: "koala_bear" },
      { emoji: "🐼", name: "panda_face" },
      { emoji: "🐔", name: "chicken_bird" },
      { emoji: "🐧", name: "penguin_bird" },
      { emoji: "🐦", name: "bird_fly" },
      { emoji: "🦆", name: "duck_bird" },
      { emoji: "🦅", name: "eagle_bird" },
      { emoji: "🦉", name: "owl_bird" },
      { emoji: "🐸", name: "frog_face" },
      { emoji: "🐢", name: "turtle_slow" },
      { emoji: "🐍", name: "snake_hiss" },
      { emoji: "🐳", name: "whale_sprout" },
      { emoji: "🐬", name: "dolphin_jump" },
      { emoji: "🐟", name: "fish_swim" },
      { emoji: "🐙", name: "octopus_legs" },
      { emoji: "🦋", name: "butterfly_fly" },
      { emoji: "💐", name: "flower_bouquet" },
      { emoji: "🌸", name: "cherry_blossom" },
      { emoji: "🌹", name: "rose_flower" },
      { emoji: "🌻", name: "sunflower_yellow" },
      { emoji: "🌲", name: "evergreen_tree" },
      { emoji: "🌳", name: "deciduous_tree" },
      { emoji: "🌴", name: "palm_tree" },
      { emoji: "🌵", name: "cactus_plant" },
      { emoji: "🔥", name: "fire_flame" },
      { emoji: "💧", name: "water_drop" },
      { emoji: "⭐", name: "star_shine" }
    ]
  },
  {
    id: "food_drink",
    name: "Food & Drink",
    emojis: [
      { emoji: "🍇", name: "grapes_fruit" },
      { emoji: "🍈", name: "melon_fruit" },
      { emoji: "🍉", name: "watermelon_slice" },
      { emoji: "🍊", name: "tangerine_orange" },
      { emoji: "🍋", name: "lemon_sour" },
      { emoji: "🍌", name: "banana_fruit" },
      { emoji: "🍍", name: "pineapple_fruit" },
      { emoji: "🍎", name: "red_apple" },
      { emoji: "🍏", name: "green_apple" },
      { emoji: "🍐", name: "pear_fruit" },
      { emoji: "🍑", name: "peach_fruit" },
      { emoji: "🍒", name: "cherries_red" },
      { emoji: "🍓", name: "strawberry_red" },
      { emoji: "🥝", name: "kiwi_fruit" },
      { emoji: "🍅", name: "tomato_red" },
      { emoji: "🥑", name: "avocado_green" },
      { emoji: "🍆", name: "eggplant_purple" },
      { emoji: "🥔", name: "potato_spud" },
      { emoji: "🥕", name: "carrot_veg" },
      { emoji: "🌽", name: "corn_cob" },
      { emoji: "🍞", name: "bread_loaf" },
      { emoji: "🧀", name: "cheese_wedge" },
      { emoji: "🍖", name: "meat_bone" },
      { emoji: "🍗", name: "poultry_leg" },
      { emoji: "🥩", name: "meat_cut" },
      { emoji: "🥓", name: "bacon_strips" },
      { emoji: "🍔", name: "hamburger_fast" },
      { emoji: "🍟", name: "french_fries" },
      { emoji: "🍕", name: "pizza_slice" },
      { emoji: "🌭", name: "hot_dog" },
      { emoji: "🥪", name: "sandwich_lunch" },
      { emoji: "🌮", name: "taco_mexican" },
      { emoji: "🌯", name: "burrito_wrap" },
      { emoji: "🥚", name: "egg_white" },
      { emoji: "🍳", name: "cooking_egg" },
      { emoji: "🍿", name: "popcorn_box" },
      { emoji: "🍚", name: "rice_bowl" },
      { emoji: "🍝", name: "spaghetti_pasta" },
      { emoji: "🍣", name: "sushi_roll" },
      { emoji: "🍤", name: "fried_shrimp" },
      { emoji: "🍦", name: "ice_cream" },
      { emoji: "🍩", name: "doughnut_sweet" },
      { emoji: "🍪", name: "cookie_sweet" },
      { emoji: "🎂", name: "birthday_cake" },
      { emoji: "🍰", name: "shortcake_slice" },
      { emoji: "🍫", name: "chocolate_bar" },
      { emoji: "🍬", name: "candy_sweet" },
      { emoji: "🍭", name: "lollipop_candy" },
      { emoji: "☕", name: "coffee_hot" },
      { emoji: "🍺", name: "beer_mug" },
      { emoji: "🍻", name: "beer_cheers" },
      { emoji: "🥂", name: "champagne_cheers" },
      { emoji: "🍷", name: "wine_glass" },
      { emoji: "🥃", name: "whiskey_glass" },
      { emoji: "🍹", name: "tropical_drink" }
    ]
  },
  {
    id: "activity",
    name: "Activity",
    emojis: [
      { emoji: "⚽", name: "soccer_ball" },
      { emoji: "🏀", name: "basketball_hoop" },
      { emoji: "🏈", name: "football_american" },
      { emoji: "⚾", name: "baseball_game" },
      { emoji: "🎾", name: "tennis_ball" },
      { emoji: "🏐", name: "volleyball_game" },
      { emoji: "🎱", name: "pool_8ball" },
      { emoji: "🏓", name: "ping_pong" },
      { emoji: "🏸", name: "badminton_game" },
      { emoji: "🥊", name: "boxing_glove" },
      { emoji: "🥅", name: "goal_net" },
      { emoji: "🎣", name: "fishing_pole" },
      { emoji: "🎮", name: "video_game" },
      { emoji: "🎲", name: "game_die" },
      { emoji: "🎭", name: "theater_masks" },
      { emoji: "🎨", name: "artist_palette" },
      { emoji: "🎬", name: "clapper_board" },
      { emoji: "🎤", name: "microphone_sing" },
      { emoji: "🎧", name: "headphone_music" },
      { emoji: "🎷", name: "saxophone_jazz" },
      { emoji: "🎸", name: "guitar_rock" },
      { emoji: "🎹", name: "piano_keys" },
      { emoji: "🎺", name: "trumpet_horn" },
      { emoji: "🎻", name: "violin_music" },
      { emoji: "🥁", name: "drum_beat" }
    ]
  },
  {
    id: "objects",
    name: "Objects",
    emojis: [
      { emoji: "📱", name: "mobile_phone" },
      { emoji: "💻", name: "laptop_computer" },
      { emoji: "🖥️", name: "desktop_computer" },
      { emoji: "⌚", name: "watch_wrist" },
      { emoji: "📷", name: "camera_photo" },
      { emoji: "💡", name: "light_bulb" },
      { emoji: "📚", name: "books_pile" },
      { emoji: "💰", name: "money_bag" },
      { emoji: "🎁", name: "gift_box" },
      { emoji: "🎈", name: "balloon_red" },
      { emoji: "🎉", name: "party_popper" },
      { emoji: "🎊", name: "confetti_ball" },
      { emoji: "✉️", name: "envelope_mail" },
      { emoji: "📦", name: "package_box" },
      { emoji: "✏️", name: "pencil_write" },
      { emoji: "🔒", name: "lock_closed" },
      { emoji: "🔑", name: "key_gold" },
      { emoji: "🔨", name: "hammer_tool" },
      { emoji: "💣", name: "bomb_explode" },
      { emoji: "🔫", name: "pistol_toy" },
      { emoji: "💊", name: "pill_capsule" },
      { emoji: "🛒", name: "shopping_cart" }
    ]
  },
  {
    id: "symbols",
    name: "Symbols",
    emojis: [
      { emoji: "❤️", name: "red_heart" },
      { emoji: "🧡", name: "orange_heart" },
      { emoji: "💛", name: "yellow_heart" },
      { emoji: "💚", name: "green_heart" },
      { emoji: "💙", name: "blue_heart" },
      { emoji: "💜", name: "purple_heart" },
      { emoji: "🖤", name: "black_heart" },
      { emoji: "🤍", name: "white_heart" },
      { emoji: "🤎", name: "brown_heart" },
      { emoji: "💔", name: "broken_heart" },
      { emoji: "❣️", name: "heart_exclamation" },
      { emoji: "💕", name: "two_hearts" },
      { emoji: "💞", name: "revolving_hearts" },
      { emoji: "💓", name: "beating_heart" },
      { emoji: "💗", name: "growing_heart" },
      { emoji: "💖", name: "sparkling_heart" },
      { emoji: "💘", name: "cupid_heart" },
      { emoji: "💝", name: "gift_heart" },
      { emoji: "💯", name: "hundred_points" },
      { emoji: "💢", name: "anger_symbol" },
      { emoji: "💥", name: "collision_boom" },
      { emoji: "💫", name: "dizzy_star" },
      { emoji: "💦", name: "sweat_drops" },
      { emoji: "💨", name: "dash_away" },
      { emoji: "💤", name: "sleeping_zzz" },
      { emoji: "✅", name: "check_mark" },
      { emoji: "❌", name: "cross_mark" },
      { emoji: "⚠️", name: "warning_sign" },
      { emoji: "⛔", name: "no_entry" },
      { emoji: "🚫", name: "prohibited_sign" },
      { emoji: "⬆️", name: "arrow_up" },
      { emoji: "⬇️", name: "arrow_down" },
      { emoji: "⬅️", name: "arrow_left" },
      { emoji: "➡️", name: "arrow_right" },
      { emoji: "♻️", name: "recycling_symbol" }
    ]
  },
  {
    id: "flags",
    name: "Flags",
    emojis: [
      { emoji: "🏁", name: "checkered_flag" },
      { emoji: "🏳️", name: "white_flag" },
      { emoji: "🏳️‍🌈", name: "rainbow_flag" },
      { emoji: "🏳️‍⚧️", name: "transgender_flag" },
      { emoji: "🏴‍☠️", name: "pirate_flag" },
      { emoji: "🇦🇨", name: "flag_ascension" },
      { emoji: "🇦🇩", name: "flag_andorra" },
      { emoji: "🇦🇪", name: "flag_uae" },
      { emoji: "🇦🇫", name: "flag_afghanistan" },
      { emoji: "🇦🇬", name: "flag_antigua" },
      { emoji: "🇦🇮", name: "flag_anguilla" },
      { emoji: "🇦🇱", name: "flag_albania" },
      { emoji: "🇦🇲", name: "flag_armenia" },
      { emoji: "🇦🇴", name: "flag_angola" },
      { emoji: "🇦🇶", name: "flag_antarctica" },
      { emoji: "🇦🇷", name: "flag_argentina" },
      { emoji: "🇦🇸", name: "flag_american_samoa" },
      { emoji: "🇦🇹", name: "flag_austria" },
      { emoji: "🇦🇺", name: "flag_australia" },
      { emoji: "🇦🇼", name: "flag_aruba" },
      { emoji: "🇦🇽", name: "flag_aland" },
      { emoji: "🇦🇿", name: "flag_azerbaijan" },
      { emoji: "🇧🇦", name: "flag_bosnia" },
      { emoji: "🇧🇧", name: "flag_barbados" },
      { emoji: "🇧🇩", name: "flag_bangladesh" },
      { emoji: "🇧🇪", name: "flag_belgium" },
      { emoji: "🇧🇫", name: "flag_burkina" },
      { emoji: "🇧🇬", name: "flag_bulgaria" },
      { emoji: "🇧🇭", name: "flag_bahrain" },
      { emoji: "🇧🇮", name: "flag_burundi" },
      { emoji: "🇧🇯", name: "flag_benin" },
      { emoji: "🇧🇱", name: "flag_st_barthelemy" },
      { emoji: "🇧🇲", name: "flag_bermuda" },
      { emoji: "🇧🇳", name: "flag_brunei" },
      { emoji: "🇧🇴", name: "flag_bolivia" },
      { emoji: "🇧🇶", name: "flag_bonaire" },
      { emoji: "🇧🇷", name: "flag_brazil" },
      { emoji: "🇧🇸", name: "flag_bahamas" },
      { emoji: "🇧🇹", name: "flag_bhutan" },
      { emoji: "🇧🇻", name: "flag_bouvet" },
      { emoji: "🇧🇼", name: "flag_botswana" },
      { emoji: "🇧🇾", name: "flag_belarus" },
      { emoji: "🇧🇿", name: "flag_belize" },
      { emoji: "🇨🇦", name: "flag_canada" },
      { emoji: "🇨🇨", name: "flag_cocos" },
      { emoji: "🇨🇩", name: "flag_congo_dr" },
      { emoji: "🇨🇫", name: "flag_central_africa" },
      { emoji: "🇨🇬", name: "flag_congo" },
      { emoji: "🇨🇭", name: "flag_switzerland" },
      { emoji: "🇨🇮", name: "flag_cote_divoire" },
      { emoji: "🇨🇰", name: "flag_cook_islands" },
      { emoji: "🇨🇱", name: "flag_chile" },
      { emoji: "🇨🇲", name: "flag_cameroon" },
      { emoji: "🇨🇳", name: "flag_china" },
      { emoji: "🇨🇴", name: "flag_colombia" },
      { emoji: "🇨🇵", name: "flag_clipperton" },
      { emoji: "🇨🇷", name: "flag_costa_rica" },
      { emoji: "🇨🇺", name: "flag_cuba" },
      { emoji: "🇨🇻", name: "flag_cape_verde" },
      { emoji: "🇨🇼", name: "flag_curacao" },
      { emoji: "🇨🇽", name: "flag_christmas_island" },
      { emoji: "🇨🇾", name: "flag_cyprus" },
      { emoji: "🇨🇿", name: "flag_czechia" },
      { emoji: "🇩🇪", name: "flag_germany" },
      { emoji: "🇩🇬", name: "flag_diego_garcia" },
      { emoji: "🇩🇯", name: "flag_djibouti" },
      { emoji: "🇩🇰", name: "flag_denmark" },
      { emoji: "🇩🇲", name: "flag_dominica" },
      { emoji: "🇩🇴", name: "flag_dominican_rep" },
      { emoji: "🇩🇿", name: "flag_algeria" },
      { emoji: "🇪🇨", name: "flag_ecuador" },
      { emoji: "🇪🇪", name: "flag_estonia" },
      { emoji: "🇪🇬", name: "flag_egypt" },
      { emoji: "🇪🇭", name: "flag_western_sahara" },
      { emoji: "🇪🇷", name: "flag_eritrea" },
      { emoji: "🇪🇸", name: "flag_spain" },
      { emoji: "🇪🇹", name: "flag_ethiopia" },
      { emoji: "🇪🇺", name: "flag_eu" },
      { emoji: "🇫🇮", name: "flag_finland" },
      { emoji: "🇫🇯", name: "flag_fiji" },
      { emoji: "🇫🇰", name: "flag_falkland" },
      { emoji: "🇫🇲", name: "flag_micronesia" },
      { emoji: "🇫🇴", name: "flag_faroe" },
      { emoji: "🇫🇷", name: "flag_france" },
      { emoji: "🇬🇦", name: "flag_gabon" },
      { emoji: "🇬🇧", name: "flag_uk" },
      { emoji: "🇬🇩", name: "flag_grenada" },
      { emoji: "🇬🇪", name: "flag_georgia" },
      { emoji: "🇬🇫", name: "flag_french_guiana" },
      { emoji: "🇬🇬", name: "flag_guernsey" },
      { emoji: "🇬🇭", name: "flag_ghana" },
      { emoji: "🇬🇮", name: "flag_gibraltar" },
      { emoji: "🇬🇱", name: "flag_greenland" },
      { emoji: "🇬🇲", name: "flag_gambia" },
      { emoji: "🇬🇳", name: "flag_guinea" },
      { emoji: "🇬🇵", name: "flag_guadeloupe" },
      { emoji: "🇬🇶", name: "flag_equatorial_guinea" },
      { emoji: "🇬🇷", name: "flag_greece" },
      { emoji: "🇬🇸", name: "flag_south_georgia" },
      { emoji: "🇬🇹", name: "flag_guatemala" },
      { emoji: "🇬🇺", name: "flag_guam" },
      { emoji: "🇬🇼", name: "flag_guinea_bissau" },
      { emoji: "🇬🇾", name: "flag_guyana" },
      { emoji: "🇭🇰", name: "flag_hong_kong" },
      { emoji: "🇭🇲", name: "flag_heard_island" },
      { emoji: "🇭🇳", name: "flag_honduras" },
      { emoji: "🇭🇷", name: "flag_croatia" },
      { emoji: "🇭🇹", name: "flag_haiti" },
      { emoji: "🇭🇺", name: "flag_hungary" },
      { emoji: "🇮🇨", name: "flag_canary_islands" },
      { emoji: "🇮🇩", name: "flag_indonesia" },
      { emoji: "🇮🇪", name: "flag_ireland" },
      { emoji: "🇮🇱", name: "flag_israel" },
      { emoji: "🇮🇲", name: "flag_isle_of_man" },
      { emoji: "🇮🇳", name: "flag_india" },
      { emoji: "🇮🇴", name: "flag_british_indian_ocean" },
      { emoji: "🇮🇶", name: "flag_iraq" },
      { emoji: "🇮🇷", name: "flag_iran" },
      { emoji: "🇮🇸", name: "flag_iceland" },
      { emoji: "🇮🇹", name: "flag_italy" },
      { emoji: "🇯🇪", name: "flag_jersey" },
      { emoji: "🇯🇲", name: "flag_jamaica" },
      { emoji: "🇯🇴", name: "flag_jordan" },
      { emoji: "🇯🇵", name: "flag_japan" },
      { emoji: "🇰🇪", name: "flag_kenya" },
      { emoji: "🇰🇬", name: "flag_kyrgyzstan" },
      { emoji: "🇰🇭", name: "flag_cambodia" },
      { emoji: "🇰🇮", name: "flag_kiribati" },
      { emoji: "🇰🇲", name: "flag_comoros" },
      { emoji: "🇰🇳", name: "flag_st_kitts" },
      { emoji: "🇰🇵", name: "flag_north_korea" },
      { emoji: "🇰🇷", name: "flag_south_korea" },
      { emoji: "🇰🇼", name: "flag_kuwait" },
      { emoji: "🇰🇾", name: "flag_cayman" },
      { emoji: "🇰🇿", name: "flag_kazakhstan" },
      { emoji: "🇱🇦", name: "flag_laos" },
      { emoji: "🇱🇧", name: "flag_lebanon" },
      { emoji: "🇱🇨", name: "flag_st_lucia" },
      { emoji: "🇱🇮", name: "flag_liechtenstein" },
      { emoji: "🇱🇰", name: "flag_sri_lanka" },
      { emoji: "🇱🇷", name: "flag_liberia" },
      { emoji: "🇱🇸", name: "flag_lesotho" },
      { emoji: "🇱🇹", name: "flag_lithuania" },
      { emoji: "🇱🇺", name: "flag_luxembourg" },
      { emoji: "🇱🇻", name: "flag_latvia" },
      { emoji: "🇱🇾", name: "flag_libya" },
      { emoji: "🇲🇦", name: "flag_morocco" },
      { emoji: "🇲🇨", name: "flag_monaco" },
      { emoji: "🇲🇩", name: "flag_moldova" },
      { emoji: "🇲🇪", name: "flag_montenegro" },
      { emoji: "🇲🇫", name: "flag_st_martin" },
      { emoji: "🇲🇬", name: "flag_madagascar" },
      { emoji: "🇲🇭", name: "flag_marshall_islands" },
      { emoji: "🇲🇰", name: "flag_north_macedonia" },
      { emoji: "🇲🇱", name: "flag_mali" },
      { emoji: "🇲🇲", name: "flag_myanmar" },
      { emoji: "🇲🇳", name: "flag_mongolia" },
      { emoji: "🇲🇴", name: "flag_macau" },
      { emoji: "🇲🇵", name: "flag_northern_mariana" },
      { emoji: "🇲🇶", name: "flag_martinique" },
      { emoji: "🇲🇷", name: "flag_mauritania" },
      { emoji: "🇲🇸", name: "flag_montserrat" },
      { emoji: "🇲🇹", name: "flag_malta" },
      { emoji: "🇲🇺", name: "flag_mauritius" },
      { emoji: "🇲🇻", name: "flag_maldives" },
      { emoji: "🇲🇼", name: "flag_malawi" },
      { emoji: "🇲🇽", name: "flag_mexico" },
      { emoji: "🇲🇾", name: "flag_malaysia" },
      { emoji: "🇲🇿", name: "flag_mozambique" },
      { emoji: "🇳🇦", name: "flag_namibia" },
      { emoji: "🇳🇨", name: "flag_new_caledonia" },
      { emoji: "🇳🇪", name: "flag_niger" },
      { emoji: "🇳🇫", name: "flag_norfolk" },
      { emoji: "🇳🇬", name: "flag_nigeria" },
      { emoji: "🇳🇮", name: "flag_nicaragua" },
      { emoji: "🇳🇱", name: "flag_netherlands" },
      { emoji: "🇳🇴", name: "flag_norway" },
      { emoji: "🇳🇵", name: "flag_nepal" },
      { emoji: "🇳🇷", name: "flag_nauru" },
      { emoji: "🇳🇺", name: "flag_niue" },
      { emoji: "🇳🇿", name: "flag_new_zealand" },
      { emoji: "🇴🇲", name: "flag_oman" },
      { emoji: "🇵🇦", name: "flag_panama" },
      { emoji: "🇵🇪", name: "flag_peru" },
      { emoji: "🇵🇫", name: "flag_french_polynesia" },
      { emoji: "🇵🇬", name: "flag_papua_new_guinea" },
      { emoji: "🇵🇭", name: "flag_philippines" },
      { emoji: "🇵🇰", name: "flag_pakistan" },
      { emoji: "🇵🇱", name: "flag_poland" },
      { emoji: "🇵🇲", name: "flag_st_pierre" },
      { emoji: "🇵🇳", name: "flag_pitcairn" },
      { emoji: "🇵🇷", name: "flag_puerto_rico" },
      { emoji: "🇵🇸", name: "flag_palestine" },
      { emoji: "🇵🇹", name: "flag_portugal" },
      { emoji: "🇵🇼", name: "flag_palau" },
      { emoji: "🇵🇾", name: "flag_paraguay" },
      { emoji: "🇶🇦", name: "flag_qatar" },
      { emoji: "🇷🇪", name: "flag_reunion" },
      { emoji: "🇷🇴", name: "flag_romania" },
      { emoji: "🇷🇸", name: "flag_serbia" },
      { emoji: "🇷🇺", name: "flag_russia" },
      { emoji: "🇷🇼", name: "flag_rwanda" },
      { emoji: "🇸🇦", name: "flag_saudi_arabia" },
      { emoji: "🇸🇧", name: "flag_solomon_islands" },
      { emoji: "🇸🇨", name: "flag_seychelles" },
      { emoji: "🇸🇩", name: "flag_sudan" },
      { emoji: "🇸🇪", name: "flag_sweden" },
      { emoji: "🇸🇬", name: "flag_singapore" },
      { emoji: "🇸🇭", name: "flag_st_helena" },
      { emoji: "🇸🇮", name: "flag_slovenia" },
      { emoji: "🇸🇯", name: "flag_svalbard" },
      { emoji: "🇸🇰", name: "flag_slovakia" },
      { emoji: "🇸🇱", name: "flag_sierra_leone" },
      { emoji: "🇸🇲", name: "flag_san_marino" },
      { emoji: "🇸🇳", name: "flag_senegal" },
      { emoji: "🇸🇴", name: "flag_somalia" },
      { emoji: "🇸🇷", name: "flag_suriname" },
      { emoji: "🇸🇸", name: "flag_south_sudan" },
      { emoji: "🇸🇹", name: "flag_sao_tome" },
      { emoji: "🇸🇻", name: "flag_el_salvador" },
      { emoji: "🇸🇽", name: "flag_sint_maarten" },
      { emoji: "🇸🇾", name: "flag_syria" },
      { emoji: "🇸🇿", name: "flag_eswatini" },
      { emoji: "🇹🇦", name: "flag_tristan" },
      { emoji: "🇹🇨", name: "flag_turks_caicos" },
      { emoji: "🇹🇩", name: "flag_chad" },
      { emoji: "🇹🇫", name: "flag_french_southern" },
      { emoji: "🇹🇬", name: "flag_togo" },
      { emoji: "🇹🇭", name: "flag_thailand" },
      { emoji: "🇹🇯", name: "flag_tajikistan" },
      { emoji: "🇹🇰", name: "flag_tokelau" },
      { emoji: "🇹🇱", name: "flag_timor_leste" },
      { emoji: "🇹🇲", name: "flag_turkmenistan" },
      { emoji: "🇹🇳", name: "flag_tunisia" },
      { emoji: "🇹🇴", name: "flag_tonga" },
      { emoji: "🇹🇷", name: "flag_turkey" },
      { emoji: "🇹🇹", name: "flag_trinidad" },
      { emoji: "🇹🇻", name: "flag_tuvalu" },
      { emoji: "🇹🇼", name: "flag_taiwan" },
      { emoji: "🇹🇿", name: "flag_tanzania" },
      { emoji: "🇺🇦", name: "flag_ukraine" },
      { emoji: "🇺🇬", name: "flag_uganda" },
      { emoji: "🇺🇲", name: "flag_us_outlying" },
      { emoji: "🇺🇳", name: "flag_un" },
      { emoji: "🇺🇸", name: "flag_usa" },
      { emoji: "🇺🇾", name: "flag_uruguay" },
      { emoji: "🇺🇿", name: "flag_uzbekistan" },
      { emoji: "🇻🇦", name: "flag_vatican" },
      { emoji: "🇻🇨", name: "flag_st_vincent" },
      { emoji: "🇻🇪", name: "flag_venezuela" },
      { emoji: "🇻🇬", name: "flag_bvi" },
      { emoji: "🇻🇮", name: "flag_usvi" },
      { emoji: "🇻🇳", name: "flag_vietnam" },
      { emoji: "🇻🇺", name: "flag_vanuatu" },
      { emoji: "🇼🇫", name: "flag_wallis" },
      { emoji: "🇼🇸", name: "flag_samoa" },
      { emoji: "🇽🇰", name: "flag_kosovo" },
      { emoji: "🇾🇪", name: "flag_yemen" },
      { emoji: "🇾🇹", name: "flag_mayotte" },
      { emoji: "🇿🇦", name: "flag_south_africa" },
      { emoji: "🇿🇲", name: "flag_zambia" },
      { emoji: "🇿🇼", name: "flag_zimbabwe" }
    ]
  }
];
